/**
 * Reports a render failure caught by a component's `errorCaptured` hook.
 *
 * Vue's default for an uncaught render error is to tear the subtree down and
 * leave a blank page, with the reason only in a console nobody has open —
 * which is how a page "just stops loading" with no clue as to why. A shell
 * that catches can keep itself alive and explain, but only if the error is
 * still written down somewhere: the UI deliberately shows generic copy,
 * because an internal message is not something to put in front of a player.
 *
 * Lives here rather than inline in the component so a test can exercise the
 * real function. `return false` stays at the call site — it is Vue's API for
 * "handled, stop propagating", not something this can do on the caller's
 * behalf.
 *
 * @param {string} scope Which surface failed, for the log line.
 * @param {Error} err The thrown error.
 * @param {object|null} vm The component that threw.
 * @param {string} info Vue's description of the hook that was running.
 * @returns {Error} The same error, so the caller can store it in one line.
 */
export function reportRenderError(scope, err, vm, info) {
    // eslint-disable-next-line no-console
    console.error(`[${scope}] render failed`, {
        err,
        info,
        component: (vm && vm.$options && vm.$options.name) || null,
    })
    return err
}
